import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import OzCenterModal from '@@/library/v4/components/OzCenterModal.vue'
import OzDrawerDraggable from '@@/library/v4/components/OzDrawerDraggable.vue'
import OzDrawerStatic from '@@/library/v4/components/OzDrawerStatic.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzScreenSizeAwareCenterModal',
  props: {
    isPhone: { type: Boolean, default: false },
    isDraggableDrawer: { type: Boolean, default: false }
  },
  emits: ['scrim-click', 'scrim-esc', 'swipedown', 'swipeup'],
  setup(__props: any) {

/**
 * @file Screen size aware drawer modal that renders OzDrawer on phone and OzCenterModal on desktop. Used in Content picker.
 */




return { __sfc: true,OzCenterModal, OzDrawerDraggable, OzDrawerStatic }
}

})